import { render, staticRenderFns } from "./AddDish.vue?vue&type=template&id=1f2d28fd&scoped=true"
import script from "./AddDish.vue?vue&type=script&lang=ts"
export * from "./AddDish.vue?vue&type=script&lang=ts"
import style0 from "./AddDish.vue?vue&type=style&index=0&id=1f2d28fd&prod&lang=scss"
import style1 from "./AddDish.vue?vue&type=style&index=1&id=1f2d28fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d28fd",
  null
  
)

export default component.exports